import React, { useRef } from "react";
import SwiperCore, { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import styled, { css } from "styled-components";
import { ArticleCard } from "./ArticleCard";
import Section from "./Section";
import Container from "./Container";
import ArrowLeftIcon from "./Icons/ArrowLeft";
import ArrowRightIcon from "./Icons/ArrowRight";
import Grid from "./Grid";

const RelatedCaseStudiesStyles = styled(Swiper)`
  ${({ ...props }) => css`
    .swiper-button-prev,
    .swiper-button-next {
      display: none;
    }
    .swiper-slide {
      height: auto;

      > a {
        height: 100%;

        @media (min-width: ${props.theme.breakpoints.lg}) {
          display: flex;
        }
      }
    }
  `}
`;

const NavigationStyles = styled.div`
  ${({ ...props }) => css`
    display: ${(props.$hiddenMobile ? "none" : "flex")};
    justify-content: center;
    margin-top: 16px;
    button {
      background: transparent;
      line-height: 32px;
      padding: 8px;
      border-radius: 50%;
      transition: all ease 0.3s;
      height: 48px;

      &:hover {
        background: #dedede;
      }

      &.swiper-button-disabled {
        opacity: 0.5;
        cursor: default;

        &:hover {
          background: none;
        }
      }
    }
    @media (min-width: ${props.theme.breakpoints.lg}) {
      display: ${(props.$hiddenDesktop ? "none" : "flex")};
    }
  `}
`;

SwiperCore.use([Navigation]);

export const RelatedCaseStudies = ({ caseStudies, grid, inversed = false }) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  if (grid) {
    return (
      <Grid as="ul" equalHeight>
        {caseStudies &&
          caseStudies.map((caseStudy, index) => {
            const article = caseStudy.featuredCaseStudy
              ? caseStudy.featuredCaseStudy
              : caseStudy.relatedCaseStudies;
            if (article && article.featuredImage?.node?.mediaItemUrl) {
              return (
                <Grid item as="li" sm="6" md="4" lg="3" key={index}>
                  <ArticleCard
                    url={article.uri}
                    title={article.title}
                    featuredImage={article.featuredImage.node.mediaItemUrl}
                    secondary="true"
                    border={inversed}
                  />
                </Grid>
              );
            }
          })}
      </Grid>
    );
  }
  return (
    <Section heading="Related Case Studies" grey={!inversed}>
      <Container>
        <RelatedCaseStudiesStyles
          slidesPerView={1}
          spaceBetween={32}
          navigation
          wrapperTag="ul"
          breakpoints={{
            640: {
              slidesPerView: 2,
              spaceBetween: 32,
            },
          }}
          onInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
            swiper.navigation.init();
            swiper.navigation.update();
          }}
        >
          {caseStudies &&
            caseStudies.map((caseStudy, index) => {
              const article = caseStudy.featuredCaseStudy
                ? caseStudy.featuredCaseStudy
                : caseStudy.relatedCaseStudies;
              if (article && article.featuredImage?.node?.mediaItemUrl) {
                return (
                  <SwiperSlide key={index} tag="li">
                    <ArticleCard
                      url={article.uri}
                      title={article.title}
                      featuredImage={article.featuredImage.node.mediaItemUrl}
                      callToAction="Find out more"
                      secondary="true"
                      inline="true"
                      border={inversed}
                    />
                  </SwiperSlide>
                );
              }
            })}
          <NavigationStyles
            $hiddenDesktop={caseStudies.length <= 2}
            $hiddenMobile={caseStudies.length === 1}
          >
            <button ref={prevRef} type="button">
              <span className="sr-only">Prev</span>
              <ArrowLeftIcon />
            </button>
            <button ref={nextRef} type="button">
              <span className="sr-only">Next</span>
              <ArrowRightIcon />
            </button>
          </NavigationStyles>
        </RelatedCaseStudiesStyles>
      </Container>
    </Section>
  );
};
